<div style="display: flex; justify-content: center; padding-top: 8px; padding-bottom: 8px;">
  <img class="card-header-img"
       [ngSrc]="getLogoUrl"
       alt="logo"
       width="100"
       height="75"
  >
</div>
